import * as Yup from "yup";

import { AuthKeys, validationMsgs } from "@sso/constant";
import { regexPasswordValidation } from "@sso/utils";

export const changePasswordValidation = Yup.object({
  [AuthKeys.OLD_PASSWORD]: Yup.string().required(validationMsgs.required).max(50, validationMsgs.maxlength(50)),
  [AuthKeys.NEW_PASSWORD]: Yup.string()
    .required(validationMsgs.required)
    .min(8, validationMsgs.minlength(8))
    .max(50, validationMsgs.maxlength(50))
    .matches(regexPasswordValidation, validationMsgs.complexPassword),
  [AuthKeys.CONFIRM_PASSWORD]: Yup.string()
    .required(validationMsgs.required)
    .oneOf([Yup.ref(AuthKeys.NEW_PASSWORD), null], validationMsgs.equalTo),
});
